import { FC } from 'react';
import styles from './styles.module.scss';
import { Box, Typography } from '@mui/material';
import { Container, LazyLottie, StartFreeForm } from '@/components';
import { useTranslation } from 'next-i18next';
import animationPreview from '/public/images/ourData/temp_headPlaceholder.webp';

export const HeadSection: FC = () => {
  const { t } = useTranslation('ourData');

  return (
    <Box component="section" className={styles.section}>
      <Container className={styles.containerImagesBG}>
        <LazyLottie
          dataSrc="/lotties/ourData/animation1.json"
          previewSrc={animationPreview}
          previewProps={{ alt: '', priority: true }}
        />
      </Container>
      <Container className={styles.container}>
        <Typography variant="h1" className={styles.title}>
          {t('head.title')}
        </Typography>
        <Typography variant="h3" className={styles.subtitle}>
          {t('head.subTitle')}
        </Typography>
        <StartFreeForm skipAuthView showCompliantInfo className={styles.form} />
      </Container>
    </Box>
  );
};
